import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import { setAllowRedirect } from "../actions/appActions";

const ServerDown = () => {
  return (
    <div className="flex-row flex-centered margin-top">
      <h1>Server je nedostupný!</h1>
    </div>
  );
};

export default compose(
  connect(null, { setAllowRedirect }),
  lifecycle({
    componentWillMount() {
      const { setAllowRedirect } = this.props;
      setAllowRedirect(false);
    },
    componentWillUnmount() {
      const { setAllowRedirect } = this.props;
      setAllowRedirect(true);
    }
  })
)(ServerDown);



// WEBPACK FOOTER //
// ./src/pages/ServerDown.js